import { render, staticRenderFns } from "./UiLazyImg.vue?vue&type=template&id=0b8fe086&scoped=true&"
import script from "./UiLazyImg.vue?vue&type=script&lang=js&"
export * from "./UiLazyImg.vue?vue&type=script&lang=js&"
import style0 from "./UiLazyImg.vue?vue&type=style&index=0&id=0b8fe086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fe086",
  null
  
)

export default component.exports